import React, { memo } from 'react';

import { Box, Tooltip } from '@mui/material';
import LabelCDS from 'app/shared/componentsRestyled/coreDesignSystem/LabelCDS';
import {
  LabelBorderStyle,
  LabelSize,
  LabelVariant,
} from 'app/shared/componentsRestyled/coreDesignSystem/LabelCDS/LabelCDS.constants';
import dayjs from 'dayjs';
import PropTypes from 'prop-types';

import { COMMON_DATETIME_FORMAT_FOR_TREE_ITEM } from 'constants/date';
import { checkIsMalwareBlocked } from 'utils/documents';

import { DOCUMENT_LABEL_TOOLTIP_POPPER_PROPS } from '../../../../LoanApplicationDocuments.constants';

import { MALWARE_TAG_LABEL, MALWARE_TAG_TOOLTIP } from './DocumentMalwareTag.constants';
import { DocumentMalwareTagTestIds } from './DocumentMalwareTag.testIds';

const DocumentMalwareTag = ({ documentId, isMalware = null, scanTimeUtc = null }) => {
  if (!checkIsMalwareBlocked(isMalware)) {
    return null;
  }

  const scannedAt = scanTimeUtc
    ? dayjs(scanTimeUtc).format(COMMON_DATETIME_FORMAT_FOR_TREE_ITEM)
    : null;

  const tooltipTitle = scannedAt ? `${MALWARE_TAG_TOOLTIP} (${scannedAt})` : MALWARE_TAG_TOOLTIP;

  return (
    <Tooltip PopperProps={DOCUMENT_LABEL_TOOLTIP_POPPER_PROPS} title={tooltipTitle}>
      <Box
        aria-label={tooltipTitle}
        component="span"
        data-testid={DocumentMalwareTagTestIds.getTagId(documentId)}
      >
        <LabelCDS
          withBorder
          borderStyle={LabelBorderStyle.SOLID}
          size={LabelSize.S}
          title={MALWARE_TAG_LABEL}
          variant={LabelVariant.RED}
        />
      </Box>
    </Tooltip>
  );
};

DocumentMalwareTag.propTypes = {
  documentId: PropTypes.string.isRequired,
  isMalware: PropTypes.bool,
  scanTimeUtc: PropTypes.string,
};

export default memo(DocumentMalwareTag);
